import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, HeartPulseIcon, SearchIcon } from 'lucide-react';
export function ProblemsSection() {
  const problems = [{
    icon: <MessageCircleIcon size={28} className="text-brand-navy" strokeWidth={1.5} data-id="element-277" />,
    image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=200&q=80',
    title: 'LIMBAJUL',
    subtitle: 'NU VORBEȘTE . VORBEȘTE PUȚIN . NU ÎNȚELEGE',
    text: 'Copilul tău spune puține cuvinte sau nu vorbește deloc. Uneori pare că înțelege, alteori nu răspunde la nimic. Auzi de la apropiați că "și vărul lui a vorbit la 4 ani", dar în interior simți că ceva nu e în regulă și că timpul nu lucrează în favoarea voastră.'
  }, {
    icon: <HeartPulseIcon size={28} className="text-brand-navy" strokeWidth={1.5} data-id="element-278" />,
    image: 'https://images.unsplash.com/photo-1471286174890-9c112ffca5b4?w=200&q=80',
    title: 'COMPORTAMENTUL',
    subtitle: 'CRIZE . AGITAȚIE . NU ASCULTĂ',
    text: 'Nu știi cum să reacționezi când copilul face crize de nervi. Uneori face ce îi ceri, alteori refuză totul. Te întrebi "de ce numără, dar nu îmi cere apă?" și simți că îl pierzi tocmai când ai nevoie să te conectezi cu el. Te folosește doar când are nevoie de ceva.'
  }, {
    icon: <SearchIcon size={28} className="text-brand-navy" strokeWidth={1.5} data-id="element-279" />,
    image: 'https://images.unsplash.com/photo-1531983412531-1f49a365ffed?w=200&q=80',
    title: 'CONFUZIA',
    subtitle: 'INFORMAȚII TRUNCHIATE . SOLUȚII CARE NU MERG',
    text: 'Ai cumpărat cursuri care nu au funcționat, ai descărcat ghiduri gratuite cu informații incomplete, ai căutat pe internet și ai găsit răspunsuri care te sperie mai mult decât te ajută. Nu știi dacă să mai aștepți, dacă să cauți un specialist sau dacă pierzi timp cu soluții greșite.'
  }];
  return <section id="probleme" className="bg-brand-beige section-padding relative overflow-hidden" data-id="element-280">
      {/* Decorative Background Arc */}
      <svg className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[1400px] h-[600px] text-brand-coral/5 pointer-events-none" viewBox="0 0 1400 600" preserveAspectRatio="none" data-id="element-281">
        <path d="M0,0 Q700,600 1400,0 L1400,600 L0,600 Z" fill="currentColor" data-id="element-282" />
      </svg>

      <div className="container-custom relative z-10" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-284">
          <h2 className="text-[26px] md:text-[36px] lg:text-[42px] max-w-[800px] mx-auto" data-id="element-285">
            Te regăsești în cel puțin una din aceste situații?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-286">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className="bg-white rounded-[16px] p-8 shadow-card border-t-[4px] border-brand-coral hover:-translate-y-2 transition-transform duration-300 relative overflow-hidden group" data-id="element-287">
              {/* Decorative corner shape */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-brand-gold/5 rounded-bl-full transition-transform duration-300 group-hover:scale-110" data-id="element-288"></div>

              <div className="flex items-center gap-4 mb-8" data-id="element-289">
                <div className="relative w-16 h-16 rounded-full overflow-hidden border-2 border-brand-gold/30 flex-shrink-0" data-id="element-290">
                  <img src={problem.image} alt={problem.title} className="w-full h-full object-cover" data-id="element-291" />
                </div>
                <div className="w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center relative" data-id="element-292">
                  {problem.icon}
                  <div className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-brand-coral border-2 border-white" data-id="element-293"></div>
                </div>
              </div>

              <h3 className="font-montserrat font-bold text-[16px] uppercase tracking-[0.1em] text-brand-navy mb-2" data-id="element-294">
                {problem.title}
              </h3>
              <p className="font-montserrat font-medium text-[12px] uppercase text-brand-textSecondary mb-6" data-id="element-295">
                {problem.subtitle}
              </p>
              <p className="text-brand-text text-[16px]" data-id="element-296">{problem.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}